import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-sogang-university',
  templateUrl: './sogang-university.component.html',
  styleUrls: ['./sogang-university.component.scss']
})
export class SogangUniversityComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    ) { }
  ngOnInit() {
    this.titleService.setTitle('Empower Your Academic Writing');
    this.metaTagService.updateTag({ name: 'description', content: 'Sogang University has partnered with Trinka to provide university-wide free access to Trinka’s advanced AI writing assistant built for academic and technical writing.' });
    this.metaTagService.updateTag({ name: 'keywords', content: '트링카클라우드, 클라우드글쓰기, 문법체크, 문법 검사기 앱, 문맥에 맞는 철자 교정, 학술적 글쓰기 앱, 기술적 글쓰기 앱, 문법 교정 툴, 자동 문법 검사기, 영문 글쓰기 툴, 실시간문법체크' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Empower Your Academic Writing' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Sogang University has partnered with Trinka to provide university-wide free access to Trinka’s advanced AI writing assistant built for academic and technical writing.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/trinkacloud' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Empower Your Academic Writing' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Sogang University has partnered with Trinka to provide university-wide free access to Trinka’s advanced AI writing assistant built for academic and technical writing." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/sogang-university' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/kr/sogang-university' });
    //this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/trinkacloud' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/sogang-university' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/trinkacloud' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/trinkacloud' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/trinkacloud' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/trinkacloud' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/trinkacloud' });
    
    
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }

}
